import React, { useCallback, useImperativeHandle, useState } from 'react'
import RoundedModal from '../../../../../../molecules/RoundedModal'
import PreviewDialogForm from './form'

const PreviewDialog = React.forwardRef(function PreviewDialog (_, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })
  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  useImperativeHandle(ref, () => ({
    open: (asset, tearSheet) => setDialogState({ asset, tearSheet, open: true, processing: false })
  }), [setDialogState])

  return (
    <RoundedModal
      title='Preview'
      open={dialogState.open}
      onClose={close}
      position='top'
      size='full'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (<PreviewDialogForm asset={dialogState.asset} tearSheet={dialogState.tearSheet} onComplete={close} onCancel={close} />) : null}
      </div>
    </RoundedModal>
  )
})

PreviewDialog.propTypes = {
}

export default PreviewDialog
